import Abstract from '../../../framework/Abstract';
import Slider from '../../../framework/Slider';

import './carousel-module.scss';

class CarouselModule extends Abstract {
	init() {
		this.setupObjectFit();

		const sliderEl = this.root.querySelector('.swiper-container');
		const prevEl = this.root.querySelector('.swiper-nav-prev');
		const nextEl = this.root.querySelector('.swiper-nav-next');
		const paginationEl = this.root.querySelector('.slider-numerical-pager');
		const navigationEl = this.root.querySelector('.slider-navigation');
		const slideElCount = this.root.querySelectorAll('.swiper-container .swiper-slide').length;
		const { duration } = this.props;

		if (slideElCount > 1) {
			navigationEl.classList.remove('is-hidden');
		}

		const sliderConfig = {
			speed: 500,
			autoplay: {
				delay: parseInt(duration, 0),
			},

			simulateTouch: false,
			preventInteractionOnTransition: true,

			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},

			navigation: {
				nextEl,
				prevEl,
			},
		};

		if (paginationEl) {
			sliderConfig.pagination = {
				type: 'numerical-pagination',
			};
		}

		this.slider = new Slider(sliderEl, sliderConfig);
	}
}

export default CarouselModule;
